export default {
  chatIconAriaLabel: 'Chat Widget Icon',
  chatIconAltText: 'kustomer-chat-icon',
};
